
import React, { useEffect } from "react";
import { Card, Accordion } from "react-bootstrap";
import Select from "react-dropdown-select";
import CustomDropdown from "../CustomDropdown";
import CustomControl from "../CustomControl";
import SelectedMotorizedStepDraperyOnly from "../SelectedMotorizedStepDraperyOnly";

export default function StepHardwareDraperyOnly({
  windowWidthPanelType,
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step6A,
  step5,
  step3A0,
  step2B,
  step2A,
  widthCart,
  modalHandleShow,
  NextStep,
  step8,
  setStep81,
  setStep8RodCheck,
  setStep82,
  setStep83,
  setStep9ADrapery,
  setStep8B,
  setStep8C,
  setSelectedDrapery,
  setSelectedSheer,
  setSelectedPrivacyLayer,
  extendedTitle,
  step6,
  setHardwareNextStep,
  setStep8,
  selectUncheck,
  setDeps,
  setCart,
  setExtendedTitle,
  selectChanged,
  inputs,
  step6BHead,
  step3,
  step31,
  step2B1,
  step2C,
  pageLanguage,
  privacyLayerSelect,
  step6CHead,
  OverlayContainer,
  rodsList,
  rodsColorList,
  rodsLoad,
  rodsLoad2,
  modelAccessories,
  step81,
  step8RodCheck,
  step83,
  GetPrice,
  isTabletOrMobile,
  selectedDrapery,
  pageLoad,
  privacyLayerSelect3,
  privacyLayerSelect2,
  hardwareNextStep,
  step6DHead,
  draperiesSelect2,
  tracksList4,
  rodsColorList5,
  step8D1,
  trackType8B,
  motorErr1,
  step8B6,
  setStep8B6,
  setMotorErr1,
  setSelectedMotorPositionB,
  setSelectedRemoteName,
  setSelectedMotorChannelsB,
  motorChannels,
  setRemoteNameB,
  setShowRemoteName,
  setCartLoading,
  selectedMotorPositionB,
  selectedRemoteName,
  selectedMotorChannelsB,
  remoteNames,
  showRemoteName,
  Capitalize,
  RemoteNameA,
  MotorPosition,
  step8B,
  step8B4,
  setStep8B4,
  step8A4,
  setStep8A4,
  setStep8D1,
  setStep8B1,
  setStep8C1,
  setStepTrackCollections9A,
  setStepControl9A,
  setStepHardware9A,
  setStep9APosition,
  step6B,
  step6C,
  step6CHead9,
  setStep6CHead9,
  hardwareDraperyStep9,
  remoteNameB,
  setStep8DTrack,
  step8DTrack,
  setStep8BRilType,
}) {
  let message = "";
  

  let optionsDrapery;


  const draperyPlaceholder = hardwareDraperyStep9 
  ? privacyLayerSelect[pageLanguage].find(item => item.value === hardwareDraperyStep9)?.label 
  : t("Please Select");
 
 

  if (step3A0 === "") {
    message = t("panel_type_text1_hardware_draperyOnly");
  } else if (step3 === "") {
    message = t("panel_type_text4_hardware_draperyOnly");
  } else if (step5 === "") {
    message = t("panel_type_text6_hardware_draperyOnly");
  } else if (step6A === "") {
    message = t("panel_type_text5_hardware_draperyOnly");
  } else if (step6B === "") {
    message = t("panel_type_text5_hardware_draperyOnly");
  } else if (step2B !== "None") {
    if(step6C === ""){
      message = t("panel_type_text5_hardware_draperyOnly");
    }
  }

  useEffect(() => {
    if (
      (step6CHead === "Track" && step6BHead === "Track" && step6DHead === "Track") ||
      (step6CHead === "Rod" && step6BHead === "Rod" && step6DHead === "Rod")
    ) {
      if (step6CHead === "Rod" && step6BHead === "Rod" && step6DHead === "Rod") {
        setStep6CHead9("Rod");
      }

      if (step6CHead === "Track" && step6BHead === "Track" && step6DHead === "Track") {
        setStep6CHead9("Track");
      }
    
    }
  }, [step6CHead, step6BHead, step6DHead, step5, step6C]);

  useEffect(() => {
    if (pageLoad) return;
    setCart(
      "Hardware",
      "Rod",
      "hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,ControlPositionA,RailDesignA,RailDesignEnA,RailDesignFaA,MotorPositionA,RemoteNameA,MotorChannelsA,RailIdA,RailColorEnA,RailColorFaA,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
      "DraperyHardware,SheerHardware,PrivacyLayerHardware",
      parseInt(windowWidthPanelType) <= 160
        ? [step6CHead9, step6CHead9, step6CHead9]
        : [step6CHead, step6BHead, step6DHead]
    );
  }, [step6CHead9]);



  if (parseInt(windowWidthPanelType) < 160 && step6CHead === "Rod" && step3 === "true" && step31 === "true") {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6CHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    optionsDrapery = privacyLayerSelect2[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) < 160 &&
    step6CHead === "Track" &&
    step3 === "true" &&
    step31 === "Track"
  ) {
    optionsDrapery = privacyLayerSelect2[pageLanguage];
  } else if (parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod" && step3 === "false") {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step31 === "false" &&
    step6CHead === "Rod" &&
    step3 === "true"
  ) {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (
    parseInt(windowWidthPanelType) > 160 &&
    step6CHead === "Rod" &&
    step31 === "true" &&
    step3 === "true"
  ) {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else if (parseInt(windowWidthPanelType) <= 160) {
    optionsDrapery = privacyLayerSelect3[pageLanguage];
  } else if (step6BHead === "Rod") {
    optionsDrapery = privacyLayerSelect[pageLanguage];
  } else {
    optionsDrapery = privacyLayerSelect2[pageLanguage];
  }

 
 

 



  return (
    <Card>
      <Card.Header>
        <ContextAwareToggle
          eventKey="8"
          stepNum={step5 === "Full" && step3 === "false" ? t("6") : t("7")}
          stepTitle={t("grommet_step8")}
          stepRef="8"
          type="1"
          required={requiredStep["8"]}
          stepSelected={stepSelectedLabel["8"] === undefined ? "" : stepSelectedLabel["8"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="8">
        <Card.Body>
        <div
  className={
    step6A === "" ||
    step5 === "" ||
    step3A0 === "" 
      ? "card_body_info_body card_body_info_body_grommet"
      : "noDisplay"
  }
>
            <h1 className="card_body_info_header_title title_step10">{t("more_info")}</h1>
            <hr />
            <div>
              <p className="card_body_info_text card_body_info_text_grommet">
                {message}
                <button
                  className="btn_step10"
                  onClick={() => {
                    modalHandleShow("hardwareCollections");
                  }}
                >
                  {t("Preview our hardware collections.")}
                </button>
              </p>
            </div>
            <NextStep currentStep="6" eventKey="9">
              {t("NEXT STEP")}
            </NextStep>
          </div>
          <div
        className={
          windowWidthPanelType !== undefined &&
         step5 !== "" &&
         step6A !== "" 
          ? "card-body"
         : "noDisplay"
        }
       >
            <div className="card_body2 card_body_radio card_body_radio_new card_body_hardware">
              <div className="box-card-hardware-pleated-draperyOnly">
              <div className="boxHardware  radio_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("hardware1")}
                  value="1"
                  name="step8"
                  ref-num="8"
                  id="81"
                  outline="true"
                  checked={step8 === "None"}
                  onChange={(e) => {
                    setStep9APosition("");
                    setStepHardware9A("");
                    setStepControl9A("");
                    setStepTrackCollections9A("");
                    setStep8D1("");
                    setStep8DTrack("");
                    setStep8B6("");
                    setStep8C1("");
                    setStep8B1("");
                    setStep8BRilType("");
                    setStep81("");
                    setStep8RodCheck("");
                    setStep82("");
                    setStep83("");
                    setStep9ADrapery("");
                    setStep8B("");
                    setStep8C("");
                    setSelectedDrapery([]);
                    setSelectedSheer([]);
                    setSelectedPrivacyLayer([]);
                    let tempExtended = extendedTitle;
                    if (step6 === "") {
                      setHardwareNextStep("9");
                      setStep8("");
                      tempExtended["8"] = [];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      selectUncheck(e);
                      modalHandleShow("noPanelType");
                      setDeps(
                        "8",
                        "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,842,844"
                      );
                      setCart(
                        "",
                        "",
                        "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,ControlPositionA,RailDesignA,RailDesignEnA,RailDesignFaA,MotorPositionA,RemoteNameA,MotorChannelsA,RailIdA,RailColorEnA,RailColorFaA,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    } else {
                      tempExtended["8"] = [t("None")];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      setExtendedTitle(tempExtended);
                      selectChanged(e, "8A,8B,8C");
                      setStep8("None");
                      setHardwareNextStep("9");
                      if (step2B === "None") {
                        setDeps(
                          "85,86",
                          "8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8B5,8B51,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,842,844,848,845,846,847"
                        );
                      } else {
                        setDeps(
                          "85",
                          "8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8B5,8B51,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,842,844,848,,845,846,847"
                        );
                      }
                      setCart(
                        "Hardware",
                        "None",
                        "DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,ControlPositionA,RailDesignA,RailDesignEnA,RailDesignFaA,MotorPositionA,RemoteNameA,MotorChannelsA,RailIdA,RailColorEnA,RailColorFaA,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    }
                  }}
                  ref={(ref) => (inputs.current["81"] = ref)}
                />
                <label htmlFor="81">{t("None")}</label>
              </div>
              <div className="boxHardware  radio_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Rod")}
                  value="2"
                  name="step8"
                  ref-num="8"
                  id="82"
                  outline="true"
                  checked={step8 === "Rod"}
                  disabled={step3 ==="false" ? step6CHead === "Track" && parseInt(windowWidthPanelType) > 160 
                    : step31 ==="false" ?
                     step6CHead === "Track" && parseInt(windowWidthPanelType) > 160 
                    : step6CHead === "Track" }
                  onChange={(e) => {
                    setStep9APosition("");
                    setStepHardware9A("");
                    setStepControl9A("");
                    setStepTrackCollections9A("");
                    setStep8B1("");
                    setStep8BRilType("");
                    setStep8C1("");
                    setStep9ADrapery("");
                    setStep8B("");
                    setStep8C("");
                    setStep8B6("");
                    setStep8D1("");
                    setStep8DTrack("");
                    let tempExtended = extendedTitle;
                    if (step3 === "" || (step3 === "true" && step31 === "")) {
                      setHardwareNextStep("9");
                      setStep8("");
                      tempExtended["8"] = [];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      selectUncheck(e);
                      modalHandleShow("noMeasurements");
                      setDeps(
                        "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3",
                        "81,82,83,85,86,87,8A3,8A4,8B3,8B5,8B51,8B6,8C3,8C5,8C51,8C52,8C6"
                      );
                      setCart(
                        "",
                        "",
                        "Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,ControlPositionA,RailDesignA,RailDesignEnA,RailDesignFaA,MotorPositionA,RemoteNameA,MotorChannelsA,RailIdA,RailColorEnA,RailColorFaA,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                      );
                    } else {
                      selectChanged(e, "8A,8B,8C");
                      setTimeout(() => {
                        setStep8("Rod");
                      }, 300);
                      tempExtended["8"] = [t("Rod")];
                      setHardwareNextStep("9");
                      setDeps(
                         "84",
                        "8,81,82,83,85,86,87,8A3,8A4,8B3,8B5,8B51,8B6,8C3,8C5,8C51,8C52,8C6,8A1,8A2,8B1,8B2,8C1,8C2,842,844,848,845,846,847"
                      );
                      setCart(
                        "Hardware",
                        "Rod",
                        "hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,ControlPositionA,RailDesignA,RailDesignEnA,RailDesignFaA,MotorPositionA,RemoteNameA,MotorChannelsA,RailIdA,RailColorEnA,RailColorFaA,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                        "DraperyHardware,SheerHardware,PrivacyLayerHardware",
                        parseInt(windowWidthPanelType) <= 160
                          ? [step6CHead9, step6CHead9, step6CHead9]
                          : [step6CHead, step6BHead, step6DHead]
                      );
                    }
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["82"] = ref)}
                />
                <label htmlFor="82">
                  {t("Rod")}
                  {(step3 ==="false" ? step6CHead === "Track" && parseInt(windowWidthPanelType) > 160 
                    : step31 ==="false" ?
                     step6CHead === "Track" && parseInt(windowWidthPanelType) > 160 
                    : step6CHead === "Track") && (
                    <OverlayContainer
                      classNames="extension_unavailable"
                      placement="bottom"
                      children={
                        <div className="extension_unavailable_title text_underline">
                          {t("Why is this unavailable?")}
                        </div>
                      }
                      component={
                        <div className="extension_unavailable_container">
                          <div className="extension_unavailable_text">
                            {t("track_sheer_hardware_text")}
                          </div>
                        </div>
                      }
                    />
                  )}
                </label>
              </div>
              <div className="boxHardware  radio_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Track")}
                  value="3"
                  name="step8"
                  ref-num="8"
                  id="83"
                  outline="true"
                  checked={step8 === "Track"}
                  disabled={step3 ==="false" ? step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160 : step31 ==="false" ? step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160 : step6CHead === "Rod" }
                  onChange={(e) => {
                    setStep9APosition("");
                    setStepHardware9A("");
                    setStepControl9A("");
                    setStepTrackCollections9A("");
                    setStep81("");
                    setStep8RodCheck("");
                    setStep82("");
                    setStep83("");
                    setStep8B1("");
                    setStep8BRilType("");
                    setStep8C1("");
                    setStep9ADrapery("");
                    setStep8B("");
                    setStep8C("");
                    setStep8D1("");
                    setStep8DTrack("");
                    let tempExtended = extendedTitle;
                    
                      setHardwareNextStep("8A");
                      selectChanged(e, "8A,8B,8C");
                      setStep8("Track");
                      tempExtended["8"] = [t("Track")];
                      tempExtended["8A"] = [];
                      tempExtended["8B"] = [];
                      tempExtended["8C"] = [];
                      if (step2B === "None") {
                        setDeps("84", "8,81,82,83,85,86,87,8C,8A1,8A2,8B1,8B2,8C1,8C2,842,844");
                      } else {
                        setDeps("84", "8,81,82,83,85,86,87,8A1,8A2,8B1,8B2,8C1,8C2,842,844");
                      }
                      setCart(
                        "Hardware",
                        "Track",
                        "DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer"
                      );
                   
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["83"] = ref)}
                />
                <label htmlFor="83">{t("Track")}
                {(step3 ==="false" ? step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160 
                  : step31 ==="false" ? step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160 
                  : step6CHead === "Rod" ) && (
                    <OverlayContainer
                      classNames="extension_unavailable"
                      placement="bottom"
                      children={
                        <div className="extension_unavailable_title text_underline">
                          {t("Why is this unavailable?")}
                        </div>
                      }
                      component={
                        <div className="extension_unavailable_container">
                          <div className="extension_unavailable_text">
                            {t("rod_sheer_hardware_text")}
                          </div>
                        </div>
                      }
                    />
                  )}
                </label>
              </div>
              </div>

              {/* step 10 Questions */}
              <div 
               className={
                step5 !== "" && (step8 === "Rod" || step8 === "Track")
                  ? "box_rod-collection"
                  : "noDisplay"
              }>
             <div className="box100">
                  <p className="step_selection_title2">
                  {step8 === "Rod" ? t("Rod Collection") : t("Track Collection")} 
                    </p>
                  </div>
             </div>

                    {/*  حالت rod  */}

              <div
                className={
                  step8 === "Rod"
                    ? "card_body card_body_radio card_body_Rod card_body_radio card_body_Rod2 box-rod-collection-draperyOnly"
                    : "noDisplay"
                }
              >
                {rodsList}
              </div>
              <div
                className={
                  step8 === "Rod"  && (step8RodCheck === "2202" || step8RodCheck === "2201" || step8RodCheck === "2203")
                  ? "card_body card_body_radio card_body_Rod_color card_body_radio card_body_Rod2 card_body_Rod3"
                  : "noDisplay" 
                }
              >
                {/* رنگ پارچه حالت rod */}
                <div className={`box100`}>
                  <p className="step_selection_title 1">{t("step8_rod_finish_title")}</p>
                </div>
                {rodsColorList}
              </div>
      {/*  حالت تراک  */}
              <div
                className={
                  step8 === "Track"
                    ? "card_body card_body_radio card_body_Rod card_body_radio card_body_Rod2 box-rod-collection-draperyOnly"
                    : "noDisplay"
                }
              >
               
                {tracksList4}
              </div>
            
              <div
                className={
                  step8 === "Track" && (step8DTrack==="2201" || step8DTrack==="2207" || step8DTrack ==="2208")
                    ? "card_body card_body_radio card_body_Rod_color"
                    : "noDisplay"
                }
              >
            <div className={step8DTrack ==="2208" ? "noDisplay" : `box100`}>
                  <p className="step_selection_title 2">{t("step8_rod_finish_title")}</p>
                </div>
                { (step8DTrack==="2201" || step8DTrack==="2207") ? (
  rodsColorList5
) : (
  <SelectedMotorizedStepDraperyOnly
    trackType8B={trackType8B}
    motorErr1={motorErr1}
    t={t}
    step8B6={step8B6}
    selectChanged={selectChanged}
    setStep8B6={setStep8B6}
    setMotorErr1={setMotorErr1}
    setSelectedMotorPositionB={setSelectedMotorPositionB}
    setSelectedRemoteName={setSelectedRemoteName}
    setSelectedMotorChannelsB={setSelectedMotorChannelsB}
    motorChannels={motorChannels}
    pageLanguage={pageLanguage}
    setRemoteNameB={setRemoteNameB}
    setDeps={setDeps}
    setCart={setCart}
    selectUncheck={selectUncheck}
    inputs={inputs}
    modalHandleShow={modalHandleShow}
    selectedMotorPositionB={selectedMotorPositionB}
    selectedRemoteName={selectedRemoteName}
    selectedMotorChannelsB={selectedMotorChannelsB}
    remoteNames={remoteNames}
    showRemoteName={showRemoteName}
    Capitalize={Capitalize}
    pageLoad={pageLoad}
    rodsLoad={rodsLoad}
    rodsLoad2={rodsLoad2}
    RemoteNameA={RemoteNameA}
    MotorPosition={MotorPosition}
    setShowRemoteName={setShowRemoteName}
    setCartLoading={setCartLoading}
    extendedTitle={extendedTitle}
    remoteNameB={remoteNameB}
  />
)
}
              </div>

             
{/* باتن ها برای انتخاب حالت Cord Draw Track */}
              <div
                className={
                  step8 === "Track" && step8DTrack === "2201"
                    ? "card_body card_body_radio card_body_baton"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title 3">{t("Baton Option")}</p>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("None")}
                    value="1"
                    name="step83"
                    ref-num="8"
                    id="831"
                    checked={step83 === "None"}
                    onChange={(e) => {
                      setStep83("None");
                      setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3");
                      setCart(
                        undefined,
                        undefined,
                        "",
                        "BatonOptionA,ControlPositionA",
                        ["None", "None", "None"]
                      );
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("None")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["831"] = ref)}
                  />
                  <label htmlFor="831">{t("None")}</label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 30cm")}
                    value="2"
                    name="step83"
                    ref-num="8"
                    id="832"
                    checked={step83 === "Baton 30cm"}
                    onChange={(e) => {
                      setStep83("Baton 30cm");
                      setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3");
                      setCart(undefined, undefined, "", "BatonOptionA", [
                        "Baton 30cm",
                        "Baton 30cm",
                        "Baton 30cm",
                      ]);
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 30cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["832"] = ref)}
                  />
                  <label htmlFor="832">
                    {t("Baton 30cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["58"]
                          ? GetPrice(
                              modelAccessories["27"]["58"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 45cm")}
                    value="3"
                    name="step83"
                    ref-num="8"
                    id="833"
                    checked={step83 === "Baton 45cm"}
                    onChange={(e) => {
                      setStep83("Baton 45cm");
                      setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3");
                      setCart(undefined, undefined, "", "BatonOptionA", [
                        "Baton 45cm",
                        "Baton 45cm",
                        "Baton 45cm",
                      ]);
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 45cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["833"] = ref)}
                  />
                  <label htmlFor="833">
                    {t("Baton 45cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["59"]
                          ? GetPrice(
                              modelAccessories["27"]["59"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
                <div
                  className={step6CHead === "Track" ? "box33 radio_style baton_style" : "noDisplay"}
                >
                  <input
                    className="radio"
                    type="radio"
                    text={t("Cord")}
                    value="4"
                    name="step83"
                    ref-num="8"
                    id="834"
                    checked={step83 === "Cord"}
                    onChange={(e) => {
                      setStep83("Cord");
                      setDeps("", "8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3", 1);
                      setCart("", "Cord");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="4" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("Cord")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["834"] = ref)}
                  />
                  <label htmlFor="834">
                    {t("Cord")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["60"]
                          ? GetPrice(
                              modelAccessories["27"]["60"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
              </div>
{/* انتخا حالت ٔNone */}
              <div
                className={
                  step8 === "None"
                    ? "card_body card_body_radio card_body_have_hardware"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title 4">{t("step8_haveHardware_title_draperyOnly")}</p>
                </div>
                <div className="box50 radio_style">
                  <div className="same_row_selection_title">{t("Drapery Hardware")}</div>
                </div>
                <div className="box50 radio_style">
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={draperyPlaceholder}
                      portal={document.body}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedDrapery}
                      onDropdownOpen={() => {
                        let temp1 = window.scrollY;
                        window.scrollTo(window.scrollX, window.scrollY + 1);
                        setTimeout(() => {
                          let temp2 = window.scrollY;
                          if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                        }, 100);
                      }}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdown props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                          setCart("hardwareDrapery", selected[0].value);
                          setDeps("", "85,86,87", 1);
                          let tempExtended = extendedTitle;
                          tempExtended["8"][1] = (
                            <li key="1" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Drapery Hardware")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                              </span>
                            </li>
                          );
                          setExtendedTitle(tempExtended);
                          setSelectedDrapery(selected);
                        }
                      }}
                      options={optionsDrapery}
                    />
                  </div>
                </div>
               
                
                
              
              </div>

              <div
                className={
                  step6CHead9 === "Rod" &&
                  step6CHead === "Rod" &&
                  step8RodCheck !== "" &&
                  (step8RodCheck === "2201" || step8RodCheck === "2202" || step8RodCheck === "2203")
                    ? "card_body card_body_radio card_body_baton"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title 5">{t("Baton Option")}</p>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("None")}
                    value="1"
                    name="step8A4"
                    ref-num="8"
                    id="8A313"
                    checked={step8A4 === "None"}
                    onChange={(e) => {
                      setStep8A4("None");
                      if(step8 === "Rod"){
                        setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,844");
                      }else{
                        setDeps("", "83,844");
                      }
                      
                      setCart("BatonOptionA", "None");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("None")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["8A313"] = ref)}
                  />
                  <label htmlFor="8A313">{t("None")}</label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 30cm")}
                    value="2"
                    name="step8A4"
                    ref-num="8"
                    id="8A321"
                    checked={step8A4 === "Baton 30cm"}
                    onChange={(e) => {
                      setStep8A4("Baton 30cm");
                      if(step8 === "Rod"){
                        setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,844");
                      }else{
                        setDeps("", "83,844" , 1);
                      }
                      setCart("BatonOptionA", "Baton 30cm");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 30cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["8A321"] = ref)}
                  />
                  <label htmlFor="8A321">
                    {t("Baton 30cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["58"]
                          ? GetPrice(
                              modelAccessories["27"]["58"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
                <div className="box33 radio_style baton_style">
                  <input
                    className="radio"
                    type="radio"
                    text={t("Baton 45cm")}
                    value="3"
                    name="step8A4"
                    ref-num="8"
                    id="8A331"
                    checked={step8A4 === "Baton 45cm"}
                    onChange={(e) => {
                      setStep8A4("Baton 45cm");
                      if(step8 === "Rod"){
                        setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,844");
                      }else{
                        setDeps("", "83,844" ,1);
                      }
                     
                      setCart("BatonOptionA", "Baton 45cm");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 45cm")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["8A331"] = ref)}
                  />
                  <label htmlFor="8A331">
                    {t("Baton 45cm")}
                    <br />
                    <p className="surcharge_price">
                      {Object.keys(modelAccessories).length !== 0
                        ? t("Add ")
                        : t("Surcharge Applies")}
                      {modelAccessories["27"]
                        ? modelAccessories["27"]["59"]
                          ? GetPrice(
                              modelAccessories["27"]["59"]["Price"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : null
                        : null}
                    </p>
                  </label>
                </div>
              </div>

            {/* کنترل \وزیشن حالت cord */}
               <div
                className={
                  step8DTrack === "2207" && step8 === "Track"
                    ? "card_body card_body_radio card_body_baton"
                    : "noDisplay"
                }
              >
                <div className="box100">
                  <p className="step_selection_title 6">{t("Control Position")}</p>
                </div>
                <div className="box33 radio_style">
                  <div className="width_max">
                    <img
                      src={require("../../Images/drapery/grommet/cp_hardware_left.svg").default}
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      className="radio"
                      type="radio"
                      text={t("Left")}
                      value="5"
                      name="step8B4"
                      ref-num="8"
                      id="8B351"
                      checked={step8B4 === "Left"}
                      onChange={(e) => {
                        setStep8B4("Left");
                        if(step8 === "Rod"){
                          setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,848");
                        }else{
                          setDeps("", "8B3,8C,8C1,8C2,848", 1);
                        }
                        
                        setCart("ControlPositionA", "Left Control");
                        selectChanged(e);
                        let tempExtended = extendedTitle;
                        tempExtended["8"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Control Position")}
                            </span>
                            <span className="step_title_extended_list_item_text">{t("Left")}</span>
                          </li>
                        );
                        setExtendedTitle(tempExtended);
                      }}
                      ref={(ref) => (inputs.current["8B351"] = ref)}
                    />
                    <label htmlFor="8B351">{t("Left")}</label>
                  </div>
                </div>
                <div className="box33 radio_style">
                  <div className="width_max">
                    <img
                      src={require("../../Images/drapery/grommet/cp_hardware_right.svg").default}
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      className="radio"
                      type="radio"
                      text={t("Right")}
                      value="6"
                      name="step8B4"
                      ref-num="8"
                      id="8B361"
                      checked={step8B4 === "Right"}
                      onChange={(e) => {
                        setStep8B4("Right");
                        if(step8 === "Rod"){
                          setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,848");
                        }else{
                          setDeps("", "8B3,8C,8C1,8C2,848", 1);
                        }
                        setCart("ControlPositionA", "Right Control");
                        selectChanged(e);
                        let tempExtended = extendedTitle;
                        tempExtended["8"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Control Position")}
                            </span>
                            <span className="step_title_extended_list_item_text">{t("Right")}</span>
                          </li>
                        );
                        setExtendedTitle(tempExtended);
                      }}
                      ref={(ref) => (inputs.current["8B361"] = ref)}
                    />
                    <label htmlFor="8B361">{t("Right")}</label>
                  </div>
                </div>
              </div>
            </div>
            <NextStep currentStep="6" eventKey="9">
              {t("NEXT STEP")}
            </NextStep>
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}

